import { render, staticRenderFns } from "./StockInvoiceStakeholderDocumentsTotal.vue?vue&type=template&id=96aa3456&scoped=true&"
import script from "./StockInvoiceStakeholderDocumentsTotal.vue?vue&type=script&lang=js&"
export * from "./StockInvoiceStakeholderDocumentsTotal.vue?vue&type=script&lang=js&"
import style0 from "./StockInvoiceStakeholderDocumentsTotal.vue?vue&type=style&index=0&id=96aa3456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96aa3456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
